import { Col, Flex, Row } from 'antd';
import { TitleProps } from 'antd/lib/typography/Title';
import clsx from 'clsx';
import { Title } from 'components/mvp-typography';
import { halfCol } from 'lib/utils/antd';
import {
  BrainFunctionCategory,
  RequiredVisualisationData
} from 'lib/utils/business/brainfunction-categories/types';
import { BrainFunctionVisualisationComponent } from './brainfunction-visualisation';

const CategoryTitle = (props: TitleProps) => (
  <Title level={3} className="patient-dashboard__title" {...props} />
);

/**
 * Display a BrainFunctionCategory
 * The first brainfunction in the list is displayed on it's own row. The rest of the brainfunctions are listed in a 2x2 grid.
 */
export function BrainFunctionCategoryComponent(props: {
  category: BrainFunctionCategory;
  visualisationData: RequiredVisualisationData;
}) {
  const category = props.category;
  // Get the first element for the first row
  const row1 = category.visualisations[0];

  // Get the remainder of the elements for the rest of the grid
  const row2 = category.visualisations.slice(1);

  return (
    <div
      className={clsx(
        'brainfunction-category',
        category.visualisations.length > 2 && 'print-big'
      )}
    >
      <CategoryTitle>{category.title}</CategoryTitle>
      <Flex vertical gap={16} justify="center" align="center">
        <Row gutter={[16, 16]}>
          {/* <Col {...oneThirdCol} /> */}
          <Col
            {...halfCol}
            style={
              {
                // display: 'flex',
                // justifyContent: 'center',
                // border: '1px solid red'
              }
            }
          >
            <BrainFunctionVisualisationComponent
              visualisation={row1}
              visualisationData={props.visualisationData}
            />
          </Col>
        </Row>
        <Row gutter={[16 * 3, 16 * 3]}>
          {
            // Render all visualisations in the category
            row2.map((unknownVisualisation, i) => {
              return (
                <Col
                  {...halfCol}
                  key={i}
                  style={{
                    display: 'flex',
                    // justifyContent: 'center'
                    justifyContent: i % 2 == 0 ? 'flex-end' : 'flex-start'
                    // border: '1px solid red'
                  }}
                >
                  <BrainFunctionVisualisationComponent
                    visualisation={unknownVisualisation}
                    visualisationData={props.visualisationData}
                  />
                </Col>
              );
            })
          }
        </Row>
      </Flex>
    </div>
  );
}
